import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import exampleRoutes from './modules/example'
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    name: 'tenant-login',
    path: '/project/:project/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/help/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/403',
    component: () => import('@/views/error-page/403'),
    hidden: true
  },
  {
    path: '/500',
    component: () => import('@/views/error-page/500'),
    hidden: true
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: '个人信息', icon: 'user', noCache: true }
      }
    ]
  }
  // {
  //   path: '/test1',
  //   component: Layout,
  //   meta:{title:'test1一级'},
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/test1/index'),
  //       name: 'Test1',
  //       meta: { title: '测试二级' },
  //       children:[
  //         {
  //           path: 'test1-2-1',
  //           component: () => import('@/views/test1/children/t1-test1'),
  //           name: 'Test1-1',
  //           meta: { title: '测试三级1' },
  //         },
  //         {
  //           path: 'test1-2-2',
  //           component: () => import('@/views/test1/children/t1-test2'),
  //           name: 'Test1-2',
  //           meta: { title: '测试三级2' },
  //         }
  //       ]
  //     }
  //   ]
  // }
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [{
  //     path: 'dashboard',
  //     name: 'Dashboard',
  //     component: () => import('@/views/dashboard/index'),
  //     meta: { title: '地图GIS', icon: 'gis' }
  //   }]
  // }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
// export const asyncRoutes = [
//   {
//     path: '/statistical-analysis',
//     component: Layout,
//     children: [
//       {
//         path: 'index',
//         name: 'StatisticalAnalysis',
//         component: () => import('@/views/statistical-analysis/index'),
//         meta: { title: '统计分析', icon: 'chart' }
//       }
//     ]
//   },
//   {
//     path: '/settings',
//     component: Layout,
//     redirect: '/settings/index',
//     name: 'Setting',
//     meta: { title: '系统设置', icon: 'setting' },
//     children: [
//       {
//         path: 'index',
//         name: 'SettingIndex',
//         component: () => import('@/views/settings/index'),
//         meta: { title: '系统设置', icon: 'setting' }
//       },
//       {
//         path: '/logs/login',
//         name: 'LoginLog',
//         component: () => import('@/views/logs/login-log'),
//         meta: { title: '登录日志', icon: 'login-log' }
//       },
//       {
//         path: '/logs/operation',
//         name: 'loginOperation',
//         component: () => import('@/views/logs/operation-log'),
//         meta: { title: '操作日志', icon: 'operation-log' }
//       }
//     ]
//   },
//   {
//     path: '/permission',
//     component: Layout,
//     redirect: '/permission/user',
//     alwaysShow: true, // will always show the root menu
//     name: 'Permission',
//     meta: {
//       title: '权限管理',
//       icon: 'lock',
//       roles: ['SUPER_ADMIN']
//     },
//     children: [
//       {
//         path: 'user',
//         component: () => import('@/views/permission/user/index'),
//         name: 'User',
//         meta: {
//           title: '用户管理',
//           icon: 'user',
//           roles: ['SUPER_ADMIN'] // or you can only set roles in sub nav
//         }
//       },
//       {
//         path: 'role',
//         component: () => import('@/views/permission/role/index'),
//         name: 'Role',
//         meta: {
//           title: '角色权限',
//           icon: 'role',
//           roles: ['SUPER_ADMIN']
//         }
//       },
//       {
//         path: 'menu',
//         component: () => import('@/views/permission/menu/index'),
//         name: 'Menu',
//         meta: {
//           title: '菜单管理',
//           icon: 'menu',
//           roles: ['SUPER_ADMIN']
//         }
//       },
//       {
//         path: 'post',
//         component: () => import('@/views/permission/post/index'),
//         name: 'Post',
//         meta: {
//           title: '岗位管理',
//           icon: 'post',
//           roles: ['SUPER_ADMIN']
//         }
//       },
//       {
//         path: 'user-group',
//         component: () => import('@/views/permission/user-group/index'),
//         name: 'UserGroup',
//         meta: {
//           title: '用户组管理',
//           icon: 'user-group',
//           roles: ['SUPER_ADMIN']
//         }
//       }
//     ]
//   },
//   {
//     path: '/base-info',
//     component: Layout,
//     redirect: '/base-info/index',
//     alwaysShow: true, // will always show the root menu
//     name: 'BaseInfoManage',
//     meta: {
//       title: '基地管理',
//       icon: 'list',
//       roles: ['SUPER_ADMIN']
//     },
//     children: [
//       {
//         path: 'index',
//         component: () => import('@/views/base-info/index'),
//         name: 'BaseInfo',
//         meta: {
//           title: '基地信息',
//           icon: 'base-info',
//           roles: ['SUPER_ADMIN'] // or you can only set roles in sub nav
//         }
//       },
//       {
//         path: 'land',
//         component: () => import('@/views/base-info/land/index'),
//         name: 'Land',
//         meta: {
//           title: '地块管理',
//           icon: 'land',
//           roles: ['SUPER_ADMIN']
//         }
//       },
//       {
//         path: 'block',
//         component: () => import('@/views/base-info/block/index'),
//         name: 'Block',
//         meta: {
//           title: '块区管理',
//           icon: 'block',
//           roles: ['SUPER_ADMIN']
//         }
//       }
//     ]
//   },
//   ...exampleRoutes,
//   // 404 page must be placed at the end !!!
//   { path: '*', redirect: '/404', hidden: true }
// ]
export const asyncRoutes = []
const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
